<template>
    <div class="w-100" @click="setStatus()">
        <div class="status-container" :style="{ backgroundColor: stausData.containerBgColor }">
            <div class="visual-detail-box" :style="{ backgroundColor: stausData.bgColor }">
                <div class="row">
                    <div class="col-6">
                        <div class="pt-3 pl-3 pb-3">
                            <div class="staus-icon-circle" :style="{ backgroundColor: stausData.iconColor }">
                                <i :class="stausData.iconClass"></i>
                            </div>
                            <h4 class="text-status-header" :style="{ color: stausData.headerTextColor }">{{
                                stausData.headerText }}</h4>
                            <h6 class="text-status-detail" :style="{ color: stausData.detailTextColor }">{{
                                stausData.detailText }}</h6>
                        </div>
                    </div>
                    <div class="col-6 d-flex align-items-bottom">
                        <img :src="stausData.img" class="img-fluid" style="max-width: 100%; height: auto;" />
                    </div>
                </div>
            </div>
            <div class="receipt-detail-box">
                <div class="row d-flex align-items-center">
                    <div v-for="info in details" :key="info.header" :class="hasTable ? 'col-6' : 'col-4'">
                        <h4 class="text-receipt-header" :style="{ color: stausData.subHeaderColor, opacity: 0.7 }">
                            {{ info.header }}
                        </h4>
                        <h6 class="text-receipt-detail" :style="{ color: stausData.subDetailColor }">
                            {{ info.detail }}
                        </h6>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

export default {
    name: 'OrderStatusCard',
    props: {
        receipt: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            orderStatusMocking: 'NEW'

        };
    },
    computed: {
        hasTable() {
            return !!(this.receipt?.table || this.receipt?.tableLayout)
        },
        details() {
            const baseDetails = [
                {
                    header: this.$i18n.t('orderType'),
                    detail: this.$t(this.getTypeOfOrderText(this.receipt?.typeOfOrder || ''))
                },
                {
                    header: this.$i18n.t('orderTimeStatus'),
                    detail: this.receipt?.payReceiptAt
                        ? moment(this.receipt?.payReceiptAt).format('HH:mm:ss')
                        : moment(this.receipt?.order?.ordered_at).format('HH:mm:ss')
                },
                {
                    header: this.$i18n.t('queue'),
                    detail: this.receipt?.queue || '-'
                }
            ]
            if (this.hasTable) {
                baseDetails.push({
                    header: this.$i18n.t('table'),
                    detail: this.receipt?.tableName
                })
            }
            return baseDetails
        },
        stausData() {
            const orderStatus = this.receipt?.order?.orderStatus || 'NEW'
            // const orderStatus = this.orderStatusMocking
            const orderedAt = this.receipt?.order?.orderedAt || this.receipt?.order?.ordered_at
            moment.locale(this.$i18n.locale || 'en')
            const timeAgo = orderedAt ? moment(orderedAt).fromNow() : '-'

            switch (orderStatus) {
                case 'PREPARE':
                    return {
                        iconColor: '#88460D',
                        iconClass: 'fi fi-rr-grill text-white',
                        headerText: this.$i18n.t('cooking'),
                        headerTextColor: '#88460DE5',
                        detailText: `${this.$i18n.t('orderedAt')} ${timeAgo}`,
                        detailTextColor: '#D26B13',
                        img: '/img/humanCooking.webp',
                        bgColor: '#F7CEA9',
                        containerBgColor: '#FADFC8',
                        subHeaderColor: '#88460DE5',
                        subDetailColor: '#88460D'
                    }

                case 'NEW':
                    return {
                        iconColor: '#0284C7',
                        iconClass: 'fi fi-rr-box-open text-white',
                        headerText: this.$t('newOrderDelivery'),
                        headerTextColor: '#0369A1',
                        detailText: `${this.$i18n.t('orderedAt')} ${timeAgo}`,
                        detailTextColor: '#0284C7',
                        img: '/img/newOrderHub.webp',
                        bgColor: '#E0F2FE',
                        containerBgColor: '#F0F9FF',
                        subHeaderColor: '#075985',
                        subDetailColor: '#0C4A6E'
                    }

                case 'ACCEPT':
                    return {
                        iconColor: '#388148',
                        iconClass: 'fi fi-rr-grill text-white',
                        headerText: this.$t('acceptOrderDelivery'),
                        headerTextColor: '#388148',
                        detailText: `${this.$i18n.t('orderedAt')} ${timeAgo}`,
                        detailTextColor: '#51AF65',
                        img: '/img/humanCooking2.webp',
                        bgColor: '#d2ecd8',
                        containerBgColor: '#e0f2e4',
                        subHeaderColor: '#51AF65',
                        subDetailColor: '#388148'
                    }

                case 'FINISH':
                    return {
                        iconColor: '#388148',
                        iconClass: 'fi fi-rr-hamburger-soda text-white',
                        headerText: this.$t('orderCompleted'),
                        headerTextColor: '#388148',
                        detailText: `${this.$i18n.t('thanksForOrdering')}`,
                        detailTextColor: '#51AF65',
                        img: '/img/humanCooking2.webp',
                        bgColor: '#d2ecd8',
                        containerBgColor: '#e0f2e4',
                        subHeaderColor: '#51AF65',
                        subDetailColor: '#388148'
                    }
                case 'READY_TO_SHIP':
                    const header = this.receipt.typeOfOrder == 1 ? this.$t('readyToServeDelivery') : this.$t('readyForPcikup')
                    const image = this.receipt.typeOfOrder == 1 ? '/img/foodReady.webp' : '/img/foodReadyPick.webp'

                    return {
                        iconColor: '#C69100',
                        iconClass: 'fi fi-rr-grill text-white',
                        headerText: header,
                        headerTextColor: '#C69100',
                        detailText: `${this.$i18n.t('orderedAt')} ${timeAgo}`,
                        detailTextColor: '#C69100',
                        img: image,
                        bgColor: '#FFF2CD',
                        containerBgColor: '#FFF7DF',
                        subHeaderColor: '#88460DE5',
                        subDetailColor: '#88460D'
                    }

                case 'REJECT':
                case 'CANCEL':
                    return {
                        iconColor: '#BB0006',
                        iconClass: 'fi fi-rr-grill text-white',
                        headerText: this.$i18n.t('cancel'),
                        headerTextColor: '#BB0006',
                        detailText: `${this.$i18n.t('orderedAt')} ${timeAgo}`,
                        detailTextColor: '#BB0006',
                        img: '/img/humanCancel.webp',
                        bgColor: '#FFC3C5',
                        containerBgColor: '#fed9da',
                        subHeaderColor: '#de6c70',
                        subDetailColor: '#b2595c'
                    }

            }
        }

    },
    created() {
    },
    methods: {
        setStatus() {
            const statusList = ['NEW', 'ACCEPT', 'PREPARE', 'FINISH'];
            const currentIndex = statusList.indexOf(this.orderStatusMocking);
            // Move to the next status or loop back to the first
            if (currentIndex >= 0 && currentIndex < statusList.length - 1) {
                this.orderStatusMocking = statusList[currentIndex + 1];
            } else {
                this.orderStatusMocking = statusList[0]; // Restart from beginning or if not found
            }
        },
        getTypeOfOrderText(type) {
            switch (type) {
                case 1:
                    return 'dine-in'
                case 3:
                    return 'pickupType'

                default:
                    return type;
            }
        },
    }
};
</script>
<style scoped>
.status-container {
    background-color: #FADFC8;
    aspect-ratio: 2/1;
    width: 100%;
    border-radius: 8px;
    padding: 2%;
}

.visual-detail-box {
    background-color: #F7CEA9;
    width: 100%;
    border-radius: 8px;
}

.receipt-detail-box {
    padding: 2cap;
    padding-bottom: 0;
    width: 100%;

}

.staus-icon-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    aspect-ratio: 1 / 1;
    width: 25%;
    height: auto;
    padding-top: 1.5cap;
}

.staus-icon-circle i {
    font-size: 4.5vw
}

.text-status-header {
    font-weight: 900 !important;
    margin-top: 2cap;
    margin-bottom: 0;
    font-size: 5vw
}

.text-status-detail {
    font-weight: 900 !important;
    margin: 0;
    font-size: 3vw
}

.text-receipt-header {
    color: #88460DE5;
    font-weight: 700;
    font-size: 3.5vw;
    margin-bottom: 4px;

}

.text-receipt-detail {
    color: #88460D;
    font-weight: 600;
    font-size: 4vw;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>